<div class="product-page-container">
  <umkt-loading [isLoading]="isLoading" [size]="'lg'" [showText]="true" [text]="'pages.productPage.loading' | i18n" mode="overlay"></umkt-loading>

  <div *ngIf="!isLoading && !error">
    <section class="hero-section">
    <div class="hero-content">
      <div class="hero-image">
        <img [src]="currentProduct.imageUrl | imageFallback" [alt]="currentProduct.name" (error)="onImageError($event)" />
      </div>
      <div class="hero-text">
        <umkt-breadcrumb [items]="breadcrumbItems"></umkt-breadcrumb>
        <div class="hero-header">
          <umkt-icon [icon]="currentIcon" size="md"></umkt-icon>
          <h1 class="hero-title">{{ currentProduct.name }}</h1>
        </div>
        <div
          class="hero-price"
          *ngIf="currentProduct?.productType === 'MIND' && mindCatalogHeroPrice > 0"
        >
          <span
            class="hero-price__badge"
            *ngIf="mindCatalogHeroPromo?.hasPromotion"
          >{{ 'components.productCard.ofertaClaro' | i18n }}</span>
          <span class="hero-price__label">{{ 'components.productCard.monthlyPrice' | i18n }}</span>
          <div class="hero-price__value font-highlight">
            <span class="hero-price__currency">R$</span>
            <span class="hero-price__amount">{{ mindCatalogHeroPrice | number: '1.2-2' }}</span>
            <span class="hero-price__suffix">{{ 'pages.productPage.perMonth' | i18n }}</span>
          </div>
          <div
            class="hero-price__from"
            *ngIf="mindCatalogHeroPromo?.hasPromotion"
          >
            {{ 'components.productCard.fromPriceMonthly' | i18n: { price: mindCatalogHeroOriginalFormatted } }}
          </div>
          <div
            class="hero-price__promo"
            *ngIf="mindCatalogHeroPromo?.hasPromotion"
          >
            <span>{{ mindCatalogHeroPromoDurationKey | i18n: mindCatalogHeroPromoDurationParams }}</span>
            <span>{{ 'components.productCard.promoAfterMonthly' | i18n: { price: mindCatalogHeroOriginalFormatted } }}</span>
          </div>
        </div>
        <p class="hero-description" [innerHtml]="sanitizedDescription"></p>
        <button
          *ngIf="currentProduct?.productType !== 'MIND'"
          type="button"
          class="hero-cta-button"
          (click)="scrollToPlans()"
        >
          {{ 'pages.productPage.ctaButton' | i18n }}
        </button>
        <span
          *ngIf="currentProduct?.productType === 'MIND'"
          class="hero-cta-button-wrap"
          [attr.title]="
            mindHeroAddToCartDisabled
              ? ('components.productCard.mindCategorySingleLimitHint' | i18n)
              : null
          "
        >
          <button
            type="button"
            class="hero-cta-button"
            [disabled]="mindHeroAddToCartDisabled"
            (click)="productPageMindCart.addCatalogProduct(currentProduct)"
          >
            {{ 'components.productCard.addToCart' | i18n }}
          </button>
        </span>
      </div>
    </div>
  </section>

  <section
    id="plans-section"
    class="product-plans-section"
    *ngIf="currentProduct.variations && currentProduct.variations.length > 0"
  >
    <h2 class="section-title">
      {{ 'pages.productPage.plansTitle' | i18n }} 
      <span class="highlight font-highlight">{{ 'pages.productPage.plansHighlight' | i18n }}</span>
    </h2>

    <umkt-expansable-card
      [plans]="currentProduct.variations"
      [productUuid]="currentProduct.uuid"
      [selectedPlanId]="selectedPlanId"
      (selectVariation)="onSelectVariation($event)"
      (addToCart)="onAddToCartFromCard($event, currentProduct)"
    >
      <div title>{{ currentProduct.name }}</div>
      <div content>
        <ul>
          <li *ngFor="let plan of currentProduct.variations">
            {{ plan.name }} - R$ {{ plan.price | number: '1.2-2' }}<ng-container *ngIf="!isRegistryDomainProduct">{{ 'pages.productPage.perMonth' | i18n }}</ng-container>
          </li>
        </ul>
      </div>
    </umkt-expansable-card>
  </section>

  <section class="related-products-section" *ngIf="!isCampaignMode && relatedProducts.length > 0">
    <h3 class="section-title">{{ 'pages.productPage.relatedTitle' | i18n }}</h3>
    <p class="section-description">
      {{ 'pages.productPage.relatedDescription' | i18n: { category: relatedCategoryLabel } }}
    </p>

    <umkt-carousel [items]="relatedProducts">
      <ng-template #itemTemplate let-product>
        <umkt-product-card
          [imageUrl]="product.imageUrl"
          [title]="product.name"
          [description]="product.excerpt"
          [plans]="product.variations"
          [productUuid]="product.uuid"
          [priceLabel]="'pages.productPage.priceFrom' | i18n"
          [price]="product.salesPrice ?? product.price ?? 0"
          [showAddToCart]="true"
          [showQuantitySelector]="product.productType !== 'MIND'"
          [productType]="product.productType"
          [productSku]="product.sku"
          [customFields]="product.customFields"
          (learnMore)="onLearnMore(product)"
          (addToCart)="onAddToCartFromCard($event, product)"
          mode="reduced"
        >
        </umkt-product-card>
      </ng-template>
    </umkt-carousel>
  </section>
  </div>
  
  <!-- Error display -->
  <div *ngIf="!isLoading && error" class="error-container">
    <umkt-error-display
      [retryCount]="retryCount"
      (retry)="onRetry()">
    </umkt-error-display>
  </div>
</div>